// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-body{max-height:calc(100vh - 140px);overflow-y:auto}.page-wrap{margin-bottom:50px}", ""]);
// Exports
module.exports = exports;
